import { withTranslation } from '@application/i18n/with_translation';
import type { FormWorker } from './form_manager/form_worker';
import { useFormWorkerState } from './form_manager/use_form_worker';

interface Props {
	formWorker: Readonly<FormWorker>;
}

export function DynamicFormPageLabel({ formWorker }: Props): JSX.Element | null {
	const { meta, pagePosition } = useFormWorkerState(formWorker);

	const isSinglePage = (meta?.pages.length ?? 0) <= 1;
	const leftSide = meta != null ? pagePosition + 1 : '-';
	const rightSide = meta != null ? meta?.pages.length : '-';

	return isSinglePage ? (
		<span />
	) : (
		<span tabIndex={-1} aria-live='polite'>
			{withTranslation('Feature.DynamicForms.PageStep', {
				current: leftSide.toString(),
				amount: rightSide.toString(),
			})}
		</span>
	);
}
